








import { Vue, Component } from 'vue-property-decorator';
import { topUpRecord } from '../api/index';
import RecordList from './RecordList.vue';

@Component({
  components: {
    RecordList,
  },
})
export default class TopUpRecord extends Vue {
  CONF = {
    one: {
      text: '序号',
    },
    two: {
      text: '充值金额(元)',
      field: 'money',
    },
    three: {
      text: '充值时间',
      field: 'createtime',
    },
  };
  listData = [];
  created() {
    this.getTopUpRecord();
  }
  async getTopUpRecord() {
    const res = await topUpRecord();
    this.listData = res.data;
  }
}
